import { EventInfo, PageNotFound } from 'src/pages';

export const viewMap = {
    eventInfo: <EventInfo />,
    notFound: <PageNotFound />,
};